/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountProviderTypeEnum } from './accountProviderTypeEnum';
import { AccountCategorySummary } from './accountCategorySummary';
import { AccountCountSummary } from './accountCountSummary';


export interface AccountSummaryItem { 
    count_summary: AccountCountSummary;
    provider: AccountProviderTypeEnum;
    summary: Array<AccountCategorySummary>;
}
export namespace AccountSummaryItem {
}


